import { useCallback, useEffect, useRef, useState } from 'react';

export function useSettingsMenu() {
  const [showSettingsMenu, setShowSettingsMenu] = useState(false);
  const [showMicSettings, setShowMicSettings] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const settingsRef = useRef<HTMLDivElement>(null);

  const openMicSettings = useCallback(() => {
    setShowProfile(false);
    setShowMicSettings(true);
  }, []);

  const openProfile = useCallback(() => {
    setShowMicSettings(false);
    setShowProfile(true);
  }, []);

  const closeMicSettings = useCallback(() => {
    setShowMicSettings(false);
  }, []);

  const closeProfile = useCallback(() => {
    setShowProfile(false);
  }, []);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (settingsRef.current && !settingsRef.current.contains(event.target as Node)) {
        setShowSettingsMenu(false);
      }
    }

    if (showSettingsMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showSettingsMenu]);

  return {
    showSettingsMenu,
    setShowSettingsMenu,
    showMicSettings,
    showProfile,
    openMicSettings,
    openProfile,
    closeMicSettings,
    closeProfile,
    settingsRef,
  };
}
